import {
  Box,
  Button,
  Flex,
  Grid,
  rem,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure, useHotkeys } from "@mantine/hooks";
import {
  IconBrandBootstrap,
  IconCalendar,
  IconFileExport,
  IconSearch,
} from "@tabler/icons-react";
import Avvvatars from "avvvatars-react";
import dayjs from "dayjs";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import LoadingOverlayCustom from "../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_DELIVERY } from "../../config";
import { _localization } from "../../config/location";
import { MessageResponse } from "../../model/MessageResponse";
import { SelectListItem } from "../../model/SelectListItem";
import { EmployeePointSummary } from "../../model/TblTestingTechniqueHeader";

// BÁO CÁO TIỀN ĐƠN HÀNG
const ReportTotalEmployee = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<EmployeePointSummary[]>([]);
  const [dataSum, setDataSum] = useState<EmployeePointSummary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  // const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
  //   []
  // );

  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 2, xl: 2 };

  const innitStateSearch = React.useMemo(
    () => ({
      KeySearch: "",
      FromDate: new Date(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime() +
          7 * 60 * 60 * 1000
      ).toISOString(),
      ToDate: new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
      BranchId: "",
      EmpIds: [] as string[],
    }),
    []
  );

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  const columns = React.useMemo<MRT_ColumnDef<EmployeePointSummary>[]>(
    () => [
      {
        accessorKey: "emp_name",
        header: "Tên nhân viên",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {renderedCellValue} - {row.original.emp_code}
              </Text>
            </Flex>
          ) : (
            <></>
          ),
        Footer: () => (
          <Text fw={"bold"} size="18px" c={"red"}>
            Tổng cộng
          </Text>
        ),
      },
      {
        accessorKey: "parking_fee",
        header: "Tiền gửi xe",
        Cell: ({ renderedCellValue }) => (
          <>{formatCurrencyVND(renderedCellValue)} đ</>
        ),
        Footer: () => (
          <Text fw={"bold"} size="18px" c={"red"}>
            {dataSum[0]?.parking_fee
              ? Number(dataSum[0]?.parking_fee)?.toLocaleString()
              : 0}{" "}
            đ
          </Text>
        ),
      },
      {
        accessorKey: "distance",
        header: "Số KM",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue} km</>,
        Footer: () => (
          <Text fw={"bold"} size="18px" c={"red"}>
            {dataSum[0]?.distance ? dataSum[0]?.distance : 0} km
          </Text>
        ),
      },
      {
        accessorKey: "delivery_point",
        header: "Điểm đơn giao hàng",
        size: 250,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        Footer: () => (
          <Text fw={"bold"} size="18px" c={"red"}>
            {dataSum[0]?.delivery_point}
          </Text>
        ),
      },
      {
        accessorKey: "technical_point",
        header: "Điểm KTKT",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        Footer: () => (
          <Text fw={"bold"} size="18px" c={"red"}>
            {dataSum[0]?.technical_point}
          </Text>
        ),
      },
      {
        accessorKey: "mfg_point",
        header: "Điểm lắp ráp, rã bộ",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        Footer: () => (
          <Text fw={"bold"} size="18px" c={"red"}>
            {dataSum[0]?.mfg_point}
          </Text>
        ),
      },
      {
        accessorKey: "total_point",
        header: "Tổng điểm",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        Footer: () => (
          <Text fw={"bold"} size="18px" c={"red"}>
            {dataSum[0]?.total_point}
          </Text>
        ),
      },
    ],
    [dataSum]
  );

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch"
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  const fetchData = async () => {
    if (
      formSeachInput.getValues()?.FromDate &&
      formSeachInput.getValues()?.FromDate.length > 0 &&
      formSeachInput.getValues()?.ToDate &&
      formSeachInput.getValues()?.ToDate.length > 0
    ) {
      setIsLoading(true);
      setIsRefetching(true);
      try {
        // Tạo URLSearchParams để quản lý các tham số
        const params = new URLSearchParams();

        // Thêm thông tin phân trang
        params.append(
          "Skip",
          (pagination.pageIndex * pagination.pageSize).toString()
        );
        params.append("Take", pagination.pageSize.toString());
        // Lấy giá trị từ form và thêm vào params nếu có giá trị
        const { KeySearch, FromDate, ToDate, BranchId, EmpIds } =
          formSeachInput.getValues();
        if (KeySearch) params.append("KeySearch", KeySearch);
        if (FromDate) params.append("FromDate", FromDate);
        if (ToDate) params.append("ToDate", ToDate);
        if (BranchId) params.append("BranchId", BranchId);
        // if (EmpIds && EmpIds?.length > 0) {
        //   EmpIds.forEach((item) => params.append("EmpIds", item));
        // }

        const url = `/api/v1/TblTestingTechniqueHeader/get-employee-technical-points?${params.toString()}`;

        const response = await repositoryDelivery.get<MessageResponse<any>>(
          `${url}`
        );
        if (response && response.success) {
          const result = response.data;
          setData(result?.filter((item: any) => item.emp_code !== "TỔNG CỘNG"));
          setDataSum(
            result?.filter((item: any) => item.emp_code === "TỔNG CỘNG")
          );
          setRowCount(response.totalCount);
          setIsCallFirst(true);
        } else {
          setData([]);
          setRowCount(0);
          setIsLoading(false);
        }
      } catch (error) {
        setData([]);
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
      }
    } else {
      NotificationExtension.Fails("Vui lòng chọn khoảng ngày muốn tìm kiếm !");
    }
  };

  const exportDataExcel = async () => {
    if (
      formSeachInput.getValues()?.FromDate &&
      formSeachInput.getValues()?.FromDate.length > 0 &&
      formSeachInput.getValues()?.ToDate &&
      formSeachInput.getValues()?.ToDate.length > 0
    ) {
      open(); // Hiển thị loading
      try {
        // Khởi tạo URL với các tham số phân trang
        let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
          pagination.pageSize
        }`;

        // Thêm các tham số tìm kiếm nếu có
        if (formSeachInput.getValues().KeySearch) {
          url += `&KeySearch=${formSeachInput.getValues().KeySearch}`;
        }
        if (formSeachInput.getValues().BranchId) {
          url += `&BranchId=${formSeachInput.getValues().BranchId}`;
        }
        if (formSeachInput.getValues().FromDate) {
          url += `&FromDate=${formSeachInput.getValues().FromDate}`;
        }
        if (formSeachInput.getValues().ToDate) {
          url += `&ToDate=${formSeachInput.getValues().ToDate}`;
        }
        // if (
        //   formSeachInput.getValues().EmpIds &&
        //   formSeachInput.getValues().EmpIds?.length > 0
        // ) {
        //   url += formSeachInput
        //     .getValues()
        //     .EmpIds?.map((item) => `&EmpIds=${item}`)
        //     .join("");
        // }
        // Xây dựng URL API cuối cùng
        const baseUrl = `/api/v1/TblTestingTechniqueHeader/export-summary-report${url}`;
        const _url = BASE_API_DELIVERY + baseUrl;
        const fullUrl = new URL(_url);
        const token = localStorage.getItem("token");

        // Gọi API
        const response = await fetch(fullUrl.toString(), {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token?.replace(/"/g, "")}`,
            "Content-Type": "application/vnd.ms-excel",
          },
        });
        // Kiểm tra trạng thái HTTP
        if (!response.ok) {
          NotificationExtension.Fails("Export Excel thất bại !");
        } else {
          // Xử lý file Excel
          NotificationExtension.Success("Export Excel thành công !");
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          const filename = "bao_cao_tong_nhan_vien_KTBH.xlsx"; // Tên mặc định nếu không có header
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(blobUrl);
        }
      } catch (error: any) {
        console.error("Error:", error);
      } finally {
        close(); // Đóng loading
      }
    } else {
      NotificationExtension.Fails(
        "Vui lòng chọn khoảng ngày để Export Excel !"
      );
    }
  };

  // const getDataEmployee = async () => {
  //   const res = await repositoryPos.get<MessageResponse<any>>(
  //     `/api/v1/TblDmEmployee/get-list?BranchId=${
  //       formSeachInput.getValues().BranchId
  //     }&Take=200`
  //   );

  //   if (res && res?.success) {
  //     setDataEmployeeSelect(
  //       res.data
  //         ?.filter(
  //           (item: any) =>
  //             item.id != null &&
  //             item.fullname != null &&
  //             item?.attribute1 === "2"
  //         )
  //         ?.map((item: any) => ({
  //           value: item.id?.toString(),
  //           label: `${item.code} - ${item.fullname}`,
  //         }))
  //     );
  //   }
  // };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination, isCallFirst]);

  // useEffect(() => {
  //   if (
  //     formSeachInput.getValues()?.BranchId &&
  //     formSeachInput.getValues()?.BranchId.length > 0
  //   ) {
  //     getDataEmployee();
  //   }
  // }, [formSeachInput.getValues()?.BranchId]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (135 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  useHotkeys([["Enter", () => fetchData()]]);

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["SoHd"],
        // right: ["tTienDh", "action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableStickyFooter: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <Box pos="relative">
      <LoadingOverlayCustom visible={visible} />
      <Flex justify="space-between" align="center">
        <_breadcrumb></_breadcrumb>
        <Button
          leftSection={
            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
          }
          onClick={() => exportDataExcel()}
        >
          Export Excel
        </Button>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              key={formSeachInput.key("FromDate")}
              {...formSeachInput.getInputProps("FromDate")}
              value={
                formSeachInput.getValues().FromDate
                  ? dayjs(formSeachInput.getValues().FromDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              maxDate={
                formSeachInput.getValues()?.ToDate &&
                formSeachInput.getValues()?.ToDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.ToDate)
                  : new Date()
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconCalendar color="#15aabf" />}
              clearable
              key={formSeachInput.key("ToDate")}
              {...formSeachInput.getInputProps("ToDate")}
              value={
                formSeachInput.getValues().ToDate
                  ? dayjs(formSeachInput.getValues().ToDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              minDate={
                formSeachInput.getValues()?.FromDate &&
                formSeachInput.getValues()?.FromDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.FromDate)
                  : undefined
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : ""
                )
              }
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn chi nhánh"
              size="sm"
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranch.map((item: any) => {
                return {
                  label: `${item?.att2} - ${item?.text}`,
                  value: String(item?.value ?? ""),
                };
              })}
              value={
                dataBranch.length > 0 ? formSeachInput.getValues().BranchId : ""
              }
              onChange={async (e) => {
                formSeachInput.setFieldValue("BranchId", e ? e.toString() : "");
              }}
              onClick={() => {
                if (dataBranch.length === 0) {
                  fetchDataBranch();
                }
              }}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              //   key={formSeachInput.key("BranchId")}
              //   {...formSeachInput.getInputProps("BranchId")}
            />
          </Grid.Col>
          {/* <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Nhập mã hoặc tên nhân viên"
              data={dataEmployeeSelect}
              searchable
              clearable
              leftSection={<IconUser color="#15aabf" />}
              value={formSeachInput.getValues()?.EmpIds ?? []}
              onChange={(e) =>
                formSeachInput.setValues((prev) => ({
                  ...prev,
                  EmpIds: e ? e : [],
                }))
              }
              nothingFoundMessage={
                formSeachInput.getValues().BranchId &&
                formSeachInput.getValues().BranchId.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Hãy chọn chi nhánh trước !"
              }
            />
          </Grid.Col> */}
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default ReportTotalEmployee;
